import { _ } from "i18n";
import { DatagridBackendFilterType, DatagridFilterInputType, type FilterConfig } from "../../types";
import { DiscoverGamesFilterField } from "../constants";

export const userFilters = {
	managers(): FilterConfig[] {
		return [
			{
				id: DiscoverGamesFilterField.ClubManager,
				label: _("discover.gamesTable.column.clubManager"),
				type: DatagridFilterInputType.Multiselect,
				field: DiscoverGamesFilterField.ClubManager,
				filterType: DatagridBackendFilterType.Inarray,
				options: [{ label: _("discover.gamesTable.cellValue.none"), value: "NONE" }],
				placeholder: _("discover.gamesTable.filterPlaceholder.countryManager"),
			},
			{
				id: DiscoverGamesFilterField.ContentManager,
				label: _("discover.gamesTable.column.contentManager"),
				type: DatagridFilterInputType.Multiselect,
				field: DiscoverGamesFilterField.ContentManager,
				filterType: DatagridBackendFilterType.Inarray,
				options: [{ label: _("discover.gamesTable.cellValue.none"), value: "NONE" }],
				placeholder: _("discover.gamesTable.filterPlaceholder.contentManager"),
			},
			{
				id: DiscoverGamesFilterField.Assignee,
				label: _("discover.gamesTable.column.assignee"),
				type: DatagridFilterInputType.Multiselect,
				field: DiscoverGamesFilterField.Assignee,
				filterType: DatagridBackendFilterType.Inarray,
				options: [{ label: _("discover.gamesTable.cellValue.none"), value: "NONE" }],
				placeholder: _("discover.gamesTable.filterPlaceholder.assignee"),
			},
		];
	},
	owner(): FilterConfig {
		return {
			id: DiscoverGamesFilterField.Owner,
			label: _("discover.gamesTable.filter.owner"),
			type: DatagridFilterInputType.Select,
			field: DiscoverGamesFilterField.Owner,
			filterType: DatagridBackendFilterType.Exact,
			options: [],
			placeholder: _("discover.gamesTable.filterPlaceholder.owner"),
		};
	},
};
